import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import {DangerButton} from "../CustomButton";
import {ArrowDownIcon} from "../svgs";

const CustomSelect = ({
                        disabled, value, className, onChange, options, label, title,
                        loaderLabel,
                        error,
                        retry,
                        loading,
                        dropdownClass,
                        titleClass = "pl-4 font-light",
                      }) => {

  const selectedLabel = options.find((o) => o.value === value);

  return (
    <div className={`${className ? ` ${className}` : ''}`}>
      {!!title && <div className={`${titleClass}`}>{title}</div>}

      {disabled ? <DropdownTopLabel disabled={true} retry={retry} loaderLabel={loaderLabel} selectedLabel={selectedLabel} error={error} loading={loading} label={label}/> :
        <DropdownMenu placement="bottom-end" isLoading={disabled || loading}
                      trigger={({triggerRef, testId, isSelected, ...props}) => (
                        <div ref={triggerRef} {...props}>
                          <DropdownTopLabel isSelected={isSelected} retry={retry} loaderLabel={loaderLabel} label={label}
                                            selectedLabel={selectedLabel} error={error} loading={loading}/>
                        </div>
                      )}>
          <DropdownItemGroup>
            {options.map((op) =>
              <DropdownItem key={op.value} onClick={() => onChange(op.value)}>
                {op.label}
              </DropdownItem>)}

          </DropdownItemGroup>
        </DropdownMenu>}


    </div>
  );
};

export default CustomSelect;

const DropdownTopLabel = ({className, isSelected, disabled, loaderLabel, selectedLabel, retry, error, loading, label}) => {
  return (
    <div
      className={`${className ? `${className} ` : ''}flex pointer-none justify-between bg-white space-x-2 items-center border border-gray-300 px-3 py-1.5 rounded ${isSelected ? 'border-secondary-600' : ''} ${disabled ? 'cursor-not-allowed text-gray-400 bg-gray-300' : 'cursor-pointer'}`}>
      <div
        className="text-gray-500 whitespace-nowrap">{error ? error : loading ? (loaderLabel ?? 'loading') : selectedLabel ? selectedLabel.label : label ?? 'Not Selected'}</div>
      {error ? <DangerButton onClick={retry}>Retry</DangerButton> : <ArrowDownIcon size="w-[15px]"/>}
    </div>
  );
};

